import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

const URL = process.env.REACT_APP_SERVER_BASE_URL

interface Environment {
  namespace: string
  chainIds: number[]
  mimicId: string
}

const fetchEnvironments = async (activeOnly: boolean): Promise<Environment[]> => {
  const url = activeOnly ? `${URL}/public/environments?active=true` : `${URL}/public/environments/`
  const response = await axios.get<Environment[]>(url)
  return response.data
}

export const useEnvironments = (activeOnly = true) => {
  return useQuery<Environment[], Error>({
    queryKey: ['environments', activeOnly],
    queryFn: () => fetchEnvironments(activeOnly),
  })
}
